export default function outils_communication() {
    let outils_communication =
        <>
            <h4>Nos outils</h4>
            <p>Stratégies de communication organisationnelle<br />
                Création de contenu multimédia | Infographie | Graphisme<br />
                Bornes interactives | Applications | Webséries internes<br />
                Vidéos interactives
            </p>
        </>

    return outils_communication;
}